import type { NuxtApp } from 'nuxt/app';
import { getSentryClient } from '@hokify/shared-components-nuxt3/lib/plugins/sentry/client';

export default defineNuxtPlugin(async (nuxtApp: NuxtApp) => {
	const {
		public: { sentry: config }
	} = useRuntimeConfig();

	const { sentry } = await getSentryClient(config, { nuxtApp, onNuxtReady });
	return {
		provide: { sentry }
	};
});
